// extracted by mini-css-extract-plugin
export default {"cls1":"MultiPaperModal-cls1__Jm","cls2":"MultiPaperModal-cls2_a7s MultiPaperModal-cls1__Jm"};